<ng-content></ng-content>

<div class="my-10 block">
  &nbsp;
</div>
<div class="block"></div>
